@if(valueAddedTaxEntity$ | async) {
  <form [formGroup]="btwOverzichtFg">
    <snelstart-ui-text-form-control [disabledControl]="true"
                                    class="custom-input-250"
                                    formControlName="achternaamBelastingplichtige"
                                    id="achternaamBelastingplichtige"
                                    label="Naam belastingplichtige"
    >
    </snelstart-ui-text-form-control>
    <snelstart-ui-text-form-control [disabledControl]="true"
                                    class="custom-input-250"
                                    formControlName="omzetbelastingNummer"
                                    id="omzetbelastingNummer"
                                    label="Omzetbelastingnummer"
    >
    </snelstart-ui-text-form-control>
    <snelstart-ui-text-form-control class="custom-input-250"
                                    [required]="true"
                                    formControlName="naamContactPersoon"
                                    id="naamContactPersoon"
                                    label="Contactpersoon *"
    >
    </snelstart-ui-text-form-control>
    <snelstart-ui-text-form-control [required]="true"
                                    [minlength]="10"
                                    [maxlength]="10"
                                    class="custom-input-250"
                                    formControlName="telefoonnummer"
                                    id="telefoonnummer"
                                    label="Telefoonnummer *"
    >
    </snelstart-ui-text-form-control>
    <snelstart-ui-text-form-control class="custom-input-250"
                                    formControlName="functie"
                                    id="functie"
                                    label="Functie *"
    >
    </snelstart-ui-text-form-control>
  </form>
  <form [formGroup]="frequentieFg">
    <snelstart-ui-text-form-control [disabledControl]="true"
                                    class="custom-input-250"
                                    formControlName="status"
                                    id="status"
                                    label="Aangiftefrequentie"
    >
    </snelstart-ui-text-form-control>

    <!--    <snelstart-ui-select-form-control formControlName="fiscaleEenheid"-->
    <!--                                      id="fiscaleEenheid"-->
    <!--                                      label="Aangifte fiscale eenheid?"-->
    <!--                                      [options]="optionsJaNee"-->
    <!--                                      class="me-1 custom-input-250"-->
    <!--                                      (change)="saveForm()"-->
    <!--    >-->
    <!--    </snelstart-ui-select-form-control>-->
    <!--    <snelstart-ui-text-form-control *ngIf="btwOverzichtFg.get('fiscaleEenheid')?.getRawValue() === true"-->
    <!--                                    formControlName="omzetbelastingNummerFE"-->
    <!--                                    id="omzetbelastingNummerFE"-->
    <!--                                    label="Fiscaal nummer fiscale eenheid"-->
    <!--                                    class="me-1 custom-input-250"-->
    <!--                                    (change)="saveForm()"-->
    <!--    >-->
    <!--    </snelstart-ui-text-form-control>-->
  </form>
}


